module.exports = __webpack_public_path__ + "img/ECR-100_1.38107371.png";